import { useNativeQueueAutoSync } from '@/lib/nativeSync/useNativeQueueAutoSync'

export function useQueueAutoSync(): void {
  useNativeQueueAutoSync()
}
